import { DomainEventType } from '../enums';

export interface DomainEventPayload {
  type: DomainEventType;
  userId?: string;
  payload: Record<string, unknown>;
}

export interface AdminActionPayload {
  actionType: string;
  targetId?: string;
  metadata?: Record<string, unknown>;
}
